export class SecurityPlanEnabledResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityPlanEnabledResponse.attributeTypeMap;
    }
    constructor() {
    }
}
